export default "__VITE_ASSET__Tgzjbx_h__"